const bodyScrollLock = require('body-scroll-lock');
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;
const clearAllBodyScrollLocks = bodyScrollLock.clearAllBodyScrollLocks;

export default function mobileNav() {
    let modal = this,
        $html = $('html'),
        $wrapper = $('.wrapper'),
        $window = $(window),
        scrollTop = 0;

    modal.scrollAPI = new function () {
        let scrollAPI = this;
        scrollAPI.fix = function () {
            if (window.innerWidth < 600) {
                $('html').addClass('_ios-hidden');
                scrollTop = $window.scrollTop();
                $window.scrollTop(0);
                $wrapper.scrollTop(scrollTop);
            }
            disableBodyScroll($html, {
                reserveScrollBarGap: true,
                allowTouchMove: el => {
                    while (el && el !== document.body) {
                        if (el.getAttribute('data-enable-scroll') !== null) {
                            return true;
                        }
                        el = el.parentNode;
                    }
                },
            });
        };
        scrollAPI.loose = function () {
            if (window.innerWidth < 600) {
                $('html').removeClass('_ios-hidden');
                $window.scrollTop(scrollTop);
            }

            enableBodyScroll($html, {reserveScrollBarGap: true});
        };
    };
    $('[data-open-nav]').on('click', function () {
        $('[data-nav]').addClass('_active');
        modal.scrollAPI.fix();
    });

    $('[data-nav-close]').on('click', function () {
        $('[data-nav]').removeClass('_active');
        $('[data-nav-more]').removeClass('_active');
        modal.scrollAPI.loose();
    });
    
    $('[data-nav-open-more]').on('click', function (event) {

        event.preventDefault();

        let $data = $(this).data('nav-open-more');

        $('[data-nav-more="' + $data +'"]').addClass('_active');
        $('.header-mobile__wrap').addClass('_active');
    });

    $('[data-nav-back]').on('click', function (event) {
        event.preventDefault();
       $('[data-nav-more]').removeClass('_active');
        $('.header-mobile__wrap').removeClass('_active');
    });

    $('[data-cart-open]').on('click', function (e) {
        e.stopPropagation();
        $('.cart-aside').addClass('_active');
        modal.scrollAPI.fix();
    });

    $('body').on('click', '[data-cart-close]', function () {
        $('.cart-aside').removeClass('_active');
        modal.scrollAPI.loose();
    });
    $('[data-tooltip-close]').on('click', function (e) {
        e.preventDefault();
        $(this).parents('.tooltip--cart').removeClass('_active');
    });
}